export enum RetainerTier {
  Basic = 'basic',
  Standard = 'standard',
  Premium = 'premium'
}

export const tierDisplayName = (tier: RetainerTier) => {
  return tier.replace(/\w\S*/g, (word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase());
}

export const hoursForTier = (tier: RetainerTier) => ({
  [RetainerTier.Basic]: 5,
  [RetainerTier.Standard]: 10,
  [RetainerTier.Premium]: 20,
})[tier];
